import { logger } from '@tunasong/models'
import type { Entity, Persisted } from '@tunasong/schemas'
import { Dialog, Typography, isMobileDevice, useUploadStoredEntity } from '@tunasong/ui-lib'
import type { FC } from 'react'
import AudioRecorder from './audio-recorder.js'
import styles from './record-fab.module.css'

export interface RecordDialogProps {
  open: boolean
  /** The recording is uploaded as a child of this entity */
  parent?: Persisted<Entity>
  onClose(): void
}

/** Record audio and upload it under `parent`. Shared by the record FAB and the song's Add menu. */
export const RecordDialog: FC<RecordDialogProps> = ({ open, onClose, parent }) => {
  const { uploadNewEntity } = useUploadStoredEntity()

  const handleComplete = (name: string, audio: Blob) => {
    onClose()

    // The upload manager tells the user when an upload is refused or fails
    uploadNewEntity({ name, parentId: parent?.id ?? null, blob: audio }).catch(e =>
      logger.warn('Recording upload failed', e)
    )
  }

  return (
    <Dialog fullScreen={isMobileDevice()} open={open} onClose={onClose} title="Record Audio">
      <Typography variant="caption" className={styles.caption}>
        Tap Start recording, then Stop recording when you’re done. Save keeps the take; Discard throws it away.
      </Typography>
      <AudioRecorder style={{ height: '100%' }} parentEntity={parent} onComplete={handleComplete} />
    </Dialog>
  )
}
